import { connect } from 'react-redux';
import { compose } from 'redux';
import { actions } from '@airasia-hotels/core';
import withSearchParamsHotelList from '../withSearchParamsHotelList';
import HotelDetail from './HotelDetail.view';

const mapStateToProps = ({ filter, hotel, metadata, bigpoints, user }) => ({
  filter: filter.hotel,
  refreshToken: hotel.refreshToken,
  hotelDetail: hotel.hotelDetail,
  isFetching: hotel.hotelDetail.isFetching,
  isFailed: hotel.hotelDetail.isFailed,
  featureFlags: metadata.featureFlags,
  defaultLocaleUsed: hotel.defaultLocaleUsed,
  uhswData: metadata?.uhswData,
  bigMembership: hotel.bigMembership,
  guestReviews: hotel.guestReviews,
  bigpoints,
  subscription: user?.subscription,
  preCheckout: hotel.preCheckout,
});

const mapDispatchToProps = {
  fetchRefreshToken: actions.hotelActions.fetchRefreshToken,
  fetchHotelDetail: actions.hotelActions.fetchHotelDetail,
  fetchHotelRooms: actions.hotelActions.fetchHotelRooms,
  fetchUserSubscription: actions.userActions.fetchUserSubscription,
  clearHotelDetail: actions.hotelActions.clearHotelDetail,
  initFilterState: actions.filterActions.initHotelFilter,
  trackMobileBackButton: actions.hotelActions.trackMobileBackButton,
  trackHotelShowMoreDescriptionClicked:
    actions.hotelActions.trackHotelShowMoreDescriptionClicked,
  trackHotelShowMorePolicyClicked:
    actions.hotelActions.trackHotelShowMorePolicyClicked,
  trackHotelRoomSelected: actions.hotelActions.trackHotelRoomSelected,
  trackProductToCheckout: actions.hotelActions.trackProductToCheckout,
  updateHotelFilter: actions.filterActions.updateHotelFilter,
  trackReceivedFirstByte: actions.analyticsActions.trackReceivedFirstByte,
  trackFirstRender: actions.analyticsActions.trackFirstRender,
  trackContentDownloadCompleted:
    actions.analyticsActions.trackContentDownloadCompleted,
  trackBatchContentDownloadCompleted:
    actions.analyticsActions.trackBatchContentDownloadCompleted,
  trackReceiveApiResponse: actions.analyticsActions.trackReceiveApiResponse,
  updateHotelDetail: actions.hotelActions.updateHotelDetail,
  trackHotelSearchWidget: actions.analyticsActions.trackHotelSearchWidget,
  updateBigPointFilter: actions.filterActions.updateBigPointFilter,
  trackHotelSeeOnAMapWeb: actions.hotelActions.trackHotelSeeOnAMapWeb,
  trackHotelShowMapWeb: actions.hotelActions.trackHotelShowMapWeb,
  trackHotelMapSelectARoomWeb: actions.hotelActions.trackHotelMapSelectARoomWeb,
  trackErrorPopOutRoom: actions.hotelActions.trackErrorPopOutRoom,
  fetchGuestReview: actions.hotelActions.fetchGuestReview,
  fetchGuestReviewCompleted: actions.hotelActions.fetchGuestReviewCompleted,
  trackViewImageBanner: actions.analyticsActions.trackViewImageBanner,
  trackViewRoom: actions.analyticsActions.trackViewRoom,
  trackHotelDetailedReview: actions.hotelActions.trackHotelDetailedReview,
  trackHotelReviewClick: actions.hotelActions.trackHotelReviewClick,
  trackHotelRoomFilterUse: actions.hotelActions.trackHotelRoomFilterUse,
  trackHotelDetailedReviewPagination:
    actions.hotelActions.trackHotelDetailedReviewPagination,
  fetchPreCheckout: actions.hotelActions.fetchPreCheckout,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withSearchParamsHotelList
)(HotelDetail);
